export default [{
  path: 'document-by-link',
  name: 'documentByLink',
  component: () => import('@/app/clientarea-app/specific-document/documentByLink'),
  meta: {
  }
}]
